import React from 'react';
import { Link } from 'react-router-dom';

const ConnectionHelp = () => {
  const isEdge = navigator.userAgent.indexOf("Edg") !== -1;
  const isChrome = navigator.userAgent.indexOf("Chrome") !== -1 && !isEdge;
  const isFirefox = navigator.userAgent.indexOf("Firefox") !== -1;
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Aide à la connexion</h1>
      
      <div className="bg-slate-800/70 rounded-lg p-6 mb-8 backdrop-blur-sm">
        <h2 className="text-xl font-semibold mb-4">Problèmes de cookies tiers</h2>
        <p className="mb-4">
          Notre système d'authentification utilise des cookies tiers qui peuvent être bloqués par 
          votre navigateur. Voici les instructions pour activer les cookies tiers pour notre site:
        </p>
        
        {isEdge && (
          <div className="mb-6 p-4 border border-blue-500 rounded-lg">
            <h3 className="font-bold text-lg mb-2">Instructions pour Microsoft Edge</h3>
            <ol className="list-decimal pl-5 space-y-2">
              <li>Cliquez sur les trois points (...) en haut à droite</li>
              <li>Sélectionnez "Paramètres"</li>
              <li>Allez dans "Confidentialité, recherche et services"</li>
              <li>Sous "Prévention du suivi", sélectionnez "De base" au lieu de "Strict"</li>
              <li>Vous pouvez aussi ajouter une exception pour notre site:
                <ul className="list-disc pl-5 mt-2">
                  <li>Faites défiler jusqu'à "Cookies et autorisations du site"</li>
                  <li>Cliquez sur "Gérer et supprimer les cookies et les données du site"</li>
                  <li>Cliquez sur "Sites autorisés"</li>
                  <li>Ajoutez "cloud.appwrite.io" à la liste des exceptions</li>
                </ul>
              </li>
            </ol>
          </div>
        )}
        
        {isSafari && (
          <div className="mb-6 p-4 border border-blue-500 rounded-lg">
            <h3 className="font-bold text-lg mb-2">Instructions pour Safari</h3>
            <ol className="list-decimal pl-5 space-y-2">
              <li>Ouvrez le menu Safari en haut à gauche</li>
              <li>Sélectionnez "Préférences"</li>
              <li>Allez dans l'onglet "Confidentialité"</li>
              <li>Décochez "Empêcher le suivi sur plusieurs domaines"</li>
              <li>Vous pouvez aussi autoriser les cookies tiers pour notre site:
                <ul className="list-disc pl-5 mt-2">
                  <li>Cliquez sur "Gérer les données des sites web"</li>
                  <li>Recherchez "cloud.appwrite.io" et cliquez sur "Autoriser"</li>
                </ul>
              </li>
            </ol>
          </div>
        )}
        
        {isFirefox && (
          <div className="mb-6 p-4 border border-blue-500 rounded-lg">
            <h3 className="font-bold text-lg mb-2">Instructions pour Firefox</h3>
            <ol className="list-decimal pl-5 space-y-2">
              <li>Cliquez sur les trois barres en haut à droite</li>
              <li>Sélectionnez "Paramètres"</li>
              <li>Allez dans "Vie privée et sécurité"</li>
              <li>Sous "Protection renforcée contre le pistage", sélectionnez "Standard" ou "Personnalisée"</li>
              <li>Si vous choisissez "Personnalisée", assurez-vous que "Cookies" est réglé sur "Cookies tiers des sites visités"</li>
            </ol>
          </div>
        )}
        
        {isChrome && (
          <div className="mb-6 p-4 border border-blue-500 rounded-lg">
            <h3 className="font-bold text-lg mb-2">Instructions pour Chrome</h3>
            <ol className="list-decimal pl-5 space-y-2">
              <li>Cliquez sur les trois points en haut à droite</li>
              <li>Sélectionnez "Paramètres"</li>
              <li>Allez dans "Confidentialité et sécurité"</li>
              <li>Cliquez sur "Cookies et autres données des sites"</li>
              <li>Sélectionnez "Autoriser tous les cookies" ou "Bloquer les cookies tiers en mode navigation privée"</li>
            </ol>
          </div>
        )}
        
        {!isEdge && !isChrome && !isFirefox && !isSafari && (
          <div className="mb-6 p-4 border border-blue-500 rounded-lg">
            <h3 className="font-bold text-lg mb-2">Instructions générales</h3>
            <p>
              Veuillez consulter la documentation de votre navigateur pour savoir comment 
              autoriser les cookies tiers ou essayez d'utiliser Chrome ou Firefox.
            </p>
          </div>
        )}
        
        <div className="p-4 border border-green-500 rounded-lg mt-6">
          <h3 className="font-bold text-lg mb-2">Alternative recommandée</h3>
          <p>Pour une expérience optimale, nous vous recommandons d'utiliser Google Chrome, qui est le navigateur le plus compatible avec notre système d'authentification.</p>
        </div>
      </div>
      
      <div className="text-center">
        <Link to="/login" className="inline-block bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-lg transition-colors">
          Retour à la page de connexion
        </Link>
      </div>
    </div>
  );
};

export default ConnectionHelp;